import { render, staticRenderFns } from "./ClientContactsTabComponent.vue?vue&type=template&id=f3adf3be&scoped=true&"
import script from "./ClientContactsTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientContactsTabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClientContactsTabComponent.vue?vue&type=style&index=0&id=f3adf3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3adf3be",
  null
  
)

export default component.exports